import React from "react";
import PropTypes from "prop-types";
import { Typography } from "components";
import "./style.scss";

const AddCta = ({ onClick, text, className }) => {
  return (
    <div className={`add-btn-cta d-flex justify-content-end ${className}`}>
      <div onClick={onClick}>
        <span>+</span> &nbsp;
        <Typography component="h6" variant="body2">
          {text}
        </Typography>
      </div>
    </div>
  );
};

AddCta.prototypes = {
  onClick: PropTypes.func,
  text: PropTypes.string,
};

export default AddCta;
